module.exports = __webpack_public_path__ + "img/msgEmpty.294b95e8.png";